import { useGameStore } from "../stores/gameStore.js";
import { emit, GameEvents } from "./events.js";

export function tickStatusEffects() {
  const game = useGameStore();

  if (!game.isFighting) return;

  if (game.enemy && game.enemy.statusEffects.length > 0) {
    emit(GameEvents.STATUS_EFFECT_TICK, { target: game.enemy });
  }

  if (game.player && game.player.statusEffects.length > 0) {
    emit(GameEvents.STATUS_EFFECT_TICK, { target: game.player });
  }
}
